export enum ListingInferredType {
    FB_OTHER = 'fb:other',
    FB_PROPERTY_AUTO = 'fb:property:auto',
    FB_PROPERTY_MANUAL = 'fb:property:manual',
}

export enum ListingsTab {
    UNMATCHED = 'Unmatched',
    MATCHED = 'Matched',
    NOT_A_PROPERTY = 'Not a Property',
}

export enum UnmatchedListingCategory {
    UNREAD = 'Unread',
    READ = 'Read',
}

export enum ListingsDateRange {
    TODAY = 'today',
    WEEK = 'week',
    MONTH = 'month',
}

export const PAGE_SIZE_OPTIONS = [
    { value: 10, label: '10' },
    { value: 25, label: '25' },
    { value: 50, label: '50' },
];
